import { PositionKind } from "../position/types/position-kind";
import {
  PriceUsed,
  PricesUsed,
  pricesUsedOfKind,
} from "../position/types/price-used";
import { ServiceVariation } from "../servicevariation/types/service-variation";

/**
 * shsPricesUsed returns the prices an SHS position may show: the unit or
 * the final price, the unit price by default, see `shsPricesUsed`,
 * backend/core/omni/domain/servicekindrules/shs_positions.go.
 */
export function shsPricesUsed(
  kind: PositionKind,
  serviceVariation: ServiceVariation,
): PricesUsed {
  return pricesUsedOfKind(kind, serviceVariation, () => ({
    allowed: [PriceUsed.UnitPrice, PriceUsed.FinalPrice],
    byDefault: PriceUsed.UnitPrice,
  }));
}
